import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import SubLabel from "components/Atoms/Sublabel";

const perPage = 20;

interface MultiBookkeepingListProps extends MultiPickerListProps<server.dto.BookkeepingSmall> {
  bookkeepingSecurityScope: server.dto.BookkeepingSecurityScopes;
}

const MultiBookkeepingList = (props: MultiBookkeepingListProps) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedBookkeepingInstruction>({
    clientId: site.currentEnvironment.client.clientId,
    keyword: "",
    page: 1,
    perPage: perPage,
    visible: "onlyYes",
  });

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={v => setInstruction(v)}
    queryKey="bookkeepinglist"
    api={instruction => window.CoreApi.Bookkeeping.PaginatedSmall(instruction, props.bookkeepingSecurityScope)}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={BookkeepingListItem}
    getId={(b) => b.bookkeepingId}
    getLabel={BookkeepingListItem}
    value={props.value}
  />
};

export const BookkeepingListItem = bookkeeping => <>
  <div>
    <div>{bookkeeping.name}</div>
    <SubLabel small>{bookkeeping.code}</SubLabel>
  </div>
</>


export default MultiBookkeepingList;